export default __webpack_public_path__ + "static/media/close-alert.fbcdadf4.svg";